import { useState, useEffect } from 'react';
import { localContentService } from '../services/localContentService';
import { STATUS } from '../constants';

/**
 * Custom hook for managing website content from local db.json
 */
export const useContent = (sectionName = null) => {
  const [content, setContent] = useState([]);
  const [status, setStatus] = useState(STATUS.IDLE);
  const [error, setError] = useState(null);

  // Load content by section name
  const loadContentBySection = async (section) => {
    if (status === STATUS.LOADING) return;
    
    setStatus(STATUS.LOADING);
    setError(null);
    
    const result = await localContentService.getContentBySection(section);
    
    if (result.success) {
      setContent(result.data);
      setStatus(STATUS.SUCCESS);
    } else {
      setError(result.error);
      setStatus(STATUS.ERROR);
    }
    
    return result;
  };

  // Load all sections
  const loadAllSections = async () => {
    if (status === STATUS.LOADING) return;
    
    setStatus(STATUS.LOADING);
    setError(null);
    
    const result = await localContentService.getAllSections();
    
    if (result.success) {
      setContent(result.data);
      setStatus(STATUS.SUCCESS);
    } else {
      setError(result.error);
      setStatus(STATUS.ERROR);
    }
    
    return result;
  };

  // Auto-load content if section name is provided
  useEffect(() => {
    if (sectionName && status === STATUS.IDLE) {
      loadContentBySection(sectionName);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- initial load only when section + idle
  }, [sectionName]);

  // Get content data for a specific section
  const getSectionData = (section) => {
    const sectionContent = content.find(item => item.section_name === section);
    return sectionContent ? sectionContent.content_data : null;
  };

  // Get all content for a section
  const getSectionContent = (section) => {
    return content.filter(item => item.section_name === section);
  };

  return {
    // State
    content,
    isLoading: status === STATUS.LOADING,
    isError: status === STATUS.ERROR,
    error,
    
    // Actions
    loadContentBySection,
    loadAllSections,
    getSectionData,
    getSectionContent
  };
}; 